import { useEffect, useState } from "react"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useListaDeduplicacaoService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
// Icon

export const RecorteListasDeduplicacao = () => {
    // State
    const { listasDeduplicacao } = useAppSelector((state) => state.listaDeduplicacao)
    const { openForm, createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Use State
    const [selectedListaDeduplicacao, setSelectedListaDeduplicacao] = useState<number[]>([])
    // Hook
    const { setupListaDeduplicacao, resetListasDeduplicacao } = useListaDeduplicacaoService()
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    useEffect(() => {
        const listasDeduplicacaoDoRedux = createRecorteExtracaoForm.fields.Filtros?.listasDeduplicacao || [];

        if (listasDeduplicacaoDoRedux.length > 0) {
            setSelectedListaDeduplicacao(listasDeduplicacaoDoRedux);
        } else {
            setSelectedListaDeduplicacao([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.listasDeduplicacao]);

    // Filtra as opções para remover os itens já selecionados
    const filteredListasDeduplicacao = (listasDeduplicacao || []).filter((lista) =>
        !selectedListaDeduplicacao.includes(lista.IdVelesGeoListaDeduplicacao)
    );

    const handleListaDeduplicacaoSelectionChange = (value: any[]) => {
        const ids = (value || []).map((lista) => lista.IdVelesGeoListaDeduplicacao)
        setSelectedListaDeduplicacao(ids)

        if (ids.length > 0) {
            syncFilterWithForm({
                filtro: 'listasDeduplicacao',
                value: ids,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'listasDeduplicacao',
                formType: 'create'
            });
        }
    }

    // Use Effect
    useEffect(() => {
        setupListaDeduplicacao()
    }, [setupListaDeduplicacao])

    useEffect(() => {
        resetListasDeduplicacao()
    }, [openForm, resetListasDeduplicacao])

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredListasDeduplicacao}
                    getOptionLabel={(option) => option.Nome.toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    value={(listasDeduplicacao || []).filter(lista => selectedListaDeduplicacao.includes(lista.IdVelesGeoListaDeduplicacao))}
                    onChange={(event, value) => {
                        handleListaDeduplicacaoSelectionChange(value);
                    }}
                    noOptionsText={'Nenhuma lista encontrada'}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Listas de Deduplicação"
                        />
                    )}
                />
            </Grid>
        </>
    )
}